// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__M19Yt","page":"Pagination_page__7NLNf","active":"Pagination_active__WHlYX"};